import React, { useEffect, useRef, useState } from 'react';

const HowEngagementsStart = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const currentRef = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  const steps = [
    "Initial conversation to understand context",
    "Clear proposal defining scope and outcomes",
    "Focused delivery or training engagement"
  ];

  return (
    <section 
      ref={sectionRef}
      className="relative min-h-screen flex items-center justify-center bg-black text-white py-32 px-6 md:px-12 overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0 opacity-20">
        <img
          src="https://images.pexels.com/photos/28428586/pexels-photo-28428586.jpeg"
          alt="Abstract sphere pattern"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="container mx-auto max-w-5xl relative z-10">
        <h2 
          className="text-5xl md:text-7xl lg:text-8xl font-bold mb-16 tracking-tight"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
            transition: 'opacity 1s ease-out, transform 1s ease-out'
          }}
        >
          How engagements start
        </h2>

        <ul className="space-y-8">
          {steps.map((step, index) => (
            <li 
              key={index}
              className="text-2xl md:text-3xl lg:text-4xl font-light text-gray-300 leading-relaxed"
              style={{
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
                transition: `opacity 0.8s ease-out ${0.2 + index * 0.15}s, transform 0.8s ease-out ${0.2 + index * 0.15}s`
              }}
            >
              • {step}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default HowEngagementsStart;